"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _AnalyticsConfiguration_1 = require("./_AnalyticsConfiguration");
exports._AnalyticsConfigurationList = {
    type: "list",
    flattened: true,
    member: {
        shape: _AnalyticsConfiguration_1._AnalyticsConfiguration
    }
};
//# sourceMappingURL=_AnalyticsConfigurationList.js.map